module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-12-1915992568f68bf0ed30f1c93f34c3e3.jpg";